<template>
  <v-row justify-md="space-between" justify="start" align="center" class="mt-2 mb-3" dense>
    <v-col cols="auto">
      <slot name="back-button">
        <link-back v-if="back_route" :to="back_route" :text="back_label" />
      </slot>
    </v-col>

    <v-col cols="auto" class="d-flex flex-wrap align-center justify-end gap-2">
      <v-btn
        v-if="show_copy_url"
        color="secondary"
        :disabled="!is_published"
        outlined
        small
        @click="$emit('copy-url')"
      >
        <v-icon aria-hidden="true" left>mdi-content-copy</v-icon>
        Copy Form URL
      </v-btn>

      <v-btn
        v-if="show_qr_code"
        color="secondary"
        :disabled="!is_published"
        outlined
        small
        @click="$emit('generate-qr')"
      >
        <v-icon aria-hidden="true" left>mdi-qrcode</v-icon>
        QR Code
      </v-btn>

      <v-btn v-if="show_archive && !is_archived" color="error" outlined small @click="$emit('archive')">
        <v-icon aria-hidden="true" left>mdi-archive</v-icon>
        Archive
      </v-btn>

      <v-tooltip v-if="show_archive && is_archived" bottom :disabled="can_unarchive">
        <template v-slot:activator="{ on, attrs }">
          <div v-on="on" v-bind="attrs" class="d-inline-block ml-2">
            <v-btn color="success" outlined :disabled="!can_unarchive" @click="$emit('unarchive')">
              <v-icon aria-hidden="true" left>mdi-package-up</v-icon>
              Unarchive
            </v-btn>
          </div>
        </template>
        <span>{{ unarchive_tooltip }}</span>
      </v-tooltip>

      <slot name="custom-actions" />
    </v-col>
  </v-row>
</template>

<script>
/**
 * The buttons that sit atop the widget editor, such as "Back to ...", "Copy URL", "QR Code", "Archive", and "Unarchive".
 *
 * @example
 * <widget-editor-action-buttons
 *   :back_route="{ name: 'dashboard' }"
 *   back_label="Back to Dashboard"
 *   :is_published="true"
 *   :is_archived="false"
 *   @copy-url="onCopyUrl"
 *   @generate-qr="onGenerateQr"
 *   @archive="onArchive"
 *   @unarchive="onUnarchive"
 * />
 */

export default {
  name: 'WidgetEditorActionButtons',

  props: {
    back_route: {
      type: [String, Object],
      default: null,
    },

    back_label: {
      type: String,
      default: 'Back',
    },

    is_published: {
      type: Boolean,
      default: false,
    },

    is_archived: {
      type: Boolean,
      default: false,
    },

    can_unarchive: {
      type: Boolean,
      default: true,
    },

    unarchive_tooltip: {
      type: String,
      default: 'Only organization administrators can unarchive forms.',
    },

    show_copy_url: {
      type: Boolean,
      default: true,
    },

    show_qr_code: {
      type: Boolean,
      default: true,
    },

    show_archive: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
